export const ENTITY = 'BASIS_TYPE';
